import { ComponentParams, ComponentRendering } from '@sitecore-jss/sitecore-jss-nextjs';
import { CreateC34InlineMediaCardModel } from './C34InlineMediaCard.service';
import { CtaInlineMediaCard } from '@ahc-digital/component-library';
import { translationClasses } from '@/shared/TranslationClasses';
import { useCreateMarketingRenderingHame } from '@/shared/useCreateMarketingRenderingName';
import { checkDatasourceForRendering } from '@/shared/checkDatasourceForRendering';

interface C34InlineMediaCardProps {
  rendering: ComponentRendering & { params: ComponentParams };
  params: ComponentParams;
}

const Default = (props?: C34InlineMediaCardProps) => {
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  return (
    <CtaInlineMediaCard
      {...CreateC34InlineMediaCardModel(props)}
      id={props?.params?.AnchorLinkTargetName}
      className={translationClasses(props?.params)}
      data-component={marketingRenderingName}
    />
  );
};

export default checkDatasourceForRendering<C34InlineMediaCardProps>(Default);
